export default __webpack_public_path__ + "static/media/advantage4.a447ee68.png";